//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    badgeTitleText: {
      type: String,
      default: '',
    },
    badgePercentDiscount: {
      type: String,
      default: '',
    },
    badgeBgColor: {
      type: String,
      default: '',
    },
    badgeBgImage: {
      type: Object,
      default: null,
    },
    badgeBgX2Image: {
      type: Object,
      default: null,
    },
  },
  computed: {
    imgSrcSet() {
      const badgeBgImage = this.badgeBgImage;
      const badgeBgX2Image = this.badgeBgX2Image;
      const url1 = badgeBgImage && badgeBgImage.url;
      const url2 = badgeBgX2Image && badgeBgX2Image.url;

      const set1 = url1 ? `${url1} 1x` : null;
      const set2 = url2 ? `${url2} 2x` : null;

      return [set1, set2].filter((i) => i).join(', ');
    },
  },
};
